import React from "react";
import { VscVerifiedFilled } from "react-icons/vsc";

const Card2 = ({
  colorFirst,
  colorSecond,
  imageSourceHeader,
  imageSourceLogo,
  imageSourceProfile,
  prefix,
  suffix,
  firstName,
  middleName,
  lastName,
  jobTitle,
  company,
  aboutMe,
  informations,
  maximize = false,
  vcard = null,
  isBadge = false,
}) => {
  return (
    <div className="flex flex-col w-full relative" id="businessCard">
      <div
        className={`flex flex-col bg-white w-full items-start ${
          maximize
            ? "h-[75vh] shadow-[0px_25px_25px_rgba(122,122,122,0.5),0px_-5px_6px_rgba(122,122,122,0.2)]"
            : "max-h-[70vh] shadow-xl"
        } overflow-hidden justify-between relative`}
      >
        <div className="flex flex-col w-full h-full bg-white overflow-auto scrollbar-hide pb-20">
          <div className="flex flex-col w-full h-fit justify-start">
            {imageSourceHeader ? (
              <div
                className="h-[220px] overflow-hidden w-[120%] -ml-[45px] rounded-b-full border-b-4 flex flex-col items-center"
                style={{
                  backgroundColor: colorFirst,
                  borderColor: colorSecond,
                }}
              >
                <img src={imageSourceHeader} className="w-full" />
              </div>
            ) : (
              <div
                className="w-[120%] -ml-[45px] h-[220px] overflow-hidden rounded-b-full border-b-4"
                style={{
                  backgroundColor: colorFirst,
                  borderColor: colorSecond,
                }}
              />
            )}
            <div className="flex flex-col w-full justify-around items-center -mt-[170px] gap-5 h-fit">
              <div className="flex flex-row gap-4">
                {imageSourceLogo ? (
                  <img
                    src={imageSourceLogo}
                    className="flex flex-col h-[80px] w-[80px] bg-transparent"
                  />
                ) : null}
                {imageSourceLogo &&
                (firstName || middleName | lastName || jobTitle || company) ? (
                  <div className="flex flex-col w-1 border-2 h-full rounded-t-lg rounded-b-lg bg-white border-white" />
                ) : null}

                <div
                  className={`flex flex-col h-full justify-center ${
                    imageSourceLogo ? "" : "items-center h-[90px]"
                  }`}
                >
                  <div className="flex flex-row gap-2 text-[16px] font-bold text-white">
                    {firstName || middleName || lastName
                      ? (prefix || "") +
                        " " +
                        (firstName || "") +
                        " " +
                        (middleName || "") +
                        " " +
                        (lastName || "") +
                        " " +
                        (suffix || "")
                      : "Your name"}
                    {isBadge && (
                      <span className="group/verified relative flex text-[24px] justify-center items-center cursor-pointer">
                        <VscVerifiedFilled />
                        <span className="absolute bottom-full mb-2 hidden group-hover/verified:flex bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
                          Verified account
                        </span>
                      </span>
                    )}
                  </div>
                  <div className="text-[12px] text-gray-100">
                    {jobTitle ? jobTitle : "Job Title"}
                    {company ? " at " + company : " at Company"}
                  </div>
                </div>
              </div>
              {imageSourceProfile ? (
                <img
                  src={imageSourceProfile}
                  className={`flex flex-col h-[130px] w-[130px] bg-white border-white border-4 rounded-full ${
                    imageSourceLogo ? "" : "mt-[38px]"
                  }`}
                />
              ) : (
                <div className="flex flex-col h-[130px] w-[130px] bg-white border-gray-200 border-4 rounded-full -mt-[20px]"></div>
              )}
            </div>
          </div>

          <div className="flex flex-col w-full px-5 items-center gap-4 divide-y-2 divide-secondary mt-1">
            {aboutMe ? (
              <div className="flex flex-col w-full items-center">
                <div className="font-bold">About me</div>
                <div className="text-[14px] mt-2">
                  {aboutMe ? aboutMe : "[About me]"}
                </div>
              </div>
            ) : null}

            <div className="flex flex-col w-full items-start pt-4 py-2">
              {informations.map((val, ind) => (
                <a
                  key={ind}
                  className={`flex flex-row gap-2 justify-start items-center w-full text-wrap hover:bg-gray-100 p-2 ${val.lookup_id}-info-slug`}
                  href={val.full_url}
                  target="_blank"
                >
                  <img
                    src={val.image_url}
                    className="w-[40px] p-2 rounded-2xl"
                    style={{ backgroundColor: colorSecond }}
                  />
                  <div
                    className={`w-full truncate rounded ${
                      val.value != "" ? "p-2 cursor-pointer" : ""
                    }`}
                  >
                    {val.value}
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
        {maximize && (
          <div className="flex flex-col w-full justify-center items-center absolute bottom-3 bg-transparent py-2">
            <div
              className={`flex flex-col items-center rounded-lg px-12 py-2 text-white text-center cursor-pointer active:translate-y-1 w-fit shadow-lg ${
                maximize ? "animate-bounce" : ""
              }`}
              style={{ backgroundColor: colorFirst }}
              onClick={vcard}
            >
              Add to Contact
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Card2;
